<template>
  <div class="dashboard">
    <h1>What do you want to do today ?</h1>
    <div id="containerDashboard">
      <ButtonComponent type="primary" content="Test Auth Call" iconPath="assets/icons/discord.svg" @click="test" />
    </div>
  </div>
</template>

<script>
import ButtonComponent from '../components/ButtonComponent.vue';
import UrlLoaderService from '@/services/urlLoader';

export default {
  name: 'DashboardPage',
  components: {
    ButtonComponent
  },
  created() {
    if (!this.$store.state.dashboardLoaded) {
      setTimeout(() => {
        this.$emit('open-menu');
        this.$store.dispatch('setDashboardLoaded');
      }, 500);
    }
  },
  methods: {
    async test() {
      try {
        const response = await UrlLoaderService.get('/dashboard');
        this.apiData = response.data;
      } catch (error) {
        this.errorMessage = 'There was an error fetching the data.';
        console.error(error);
      }
    }
  }
}
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

#containerDashboard {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
